<div class="seg-form-page">
  <header>
    <button mat-button type="button" (click)="cancel()"><mat-icon>arrow_back</mat-icon> Back</button>
    <h1>New segment inspection</h1>
    <p>Register a corridor segment for supervisor verification and engineer site inspection.</p>
  </header>

  <form [formGroup]="form" (ngSubmit)="submit()" class="seg-form-card">
    <mat-form-field appearance="outline" class="full">
      <mat-label>Project</mat-label>
      <mat-select formControlName="project_id" (selectionChange)="onProjectChange($event.value)">
        <mat-option *ngFor="let p of projects" [value]="p.id">{{ p.project_name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>LRS route (optional)</mat-label>
      <mat-select formControlName="lrs_route_id">
        <mat-option [value]="null">—</mat-option>
        <mat-option *ngFor="let r of routes" [value]="r.id">{{ r.route_name }} ({{ r.route_code || r.id }})</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="row-2">
      <mat-form-field appearance="outline">
        <mat-label>Segment label</mat-label>
        <input matInput formControlName="segment_label" placeholder="e.g. Chainage 12+500 – 14+200" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Segment code</mat-label>
        <input matInput formControlName="segment_code" />
      </mat-form-field>
    </div>

    <div class="row-2">
      <mat-form-field appearance="outline">
        <mat-label>From km</mat-label>
        <input matInput formControlName="from_km" placeholder="12.500" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>To km</mat-label>
        <input matInput formControlName="to_km" placeholder="14.200" />
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="full">
      <mat-label>Work status summary</mat-label>
      <textarea matInput rows="4" formControlName="work_status_summary" placeholder="Brief execution status for inspection engineer..."></textarea>
    </mat-form-field>

    <div class="actions">
      <button mat-button type="button" (click)="cancel()">Cancel</button>
      <button mat-raised-button color="primary" type="submit" [disabled]="saving">
        {{ saving ? 'Creating...' : 'Create & open workflow' }}
      </button>
    </div>
  </form>
</div>
